import React from "react";
import "./index.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Login from "./authentication/login";
import AppLayout from "./components/Layout/Layout";
import LoginForm from "./authentication/login";
import { getAuthToken } from "./helpers/userDetails";
// import RxLabel from "./pages/RxLabel";

const RoutesWrapper = () => {
  const isLoggedIn = getAuthToken();
  const getHomePage = () => {
    if (!isLoggedIn) {
      return <LoginForm />;
    }
    return <></>;
  };

  return (
    <Router>
      {isLoggedIn && <AppLayout />}
      <Routes>
        <Route path="/" element={getHomePage()} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/rx-label" element={<RxLabel />} /> */}
      </Routes>
    </Router>
  );
};

export default RoutesWrapper;
